import React from 'react';
import Webcam from 'react-webcam';

const RecordingScreen = ({
  initialAnswer,
  recording,
  isTimerActive,
  seconds,
  formattedSeconds,
  webcamRef,
  cameraType,
  handleNext,
  handleRecord,
  styles
}) => {
  const timerStyle = {
    color: seconds < 6 ? "red" : "black",
    animation: seconds < 6 ? "blink 1s step-start infinite" : "none",
    fontSize: 18,
  };

  return (
    <div style={styles.container}>
      <div style={styles.centered}>
        <Webcam
          audio
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{ facingMode: cameraType }}
        />
      </div>
      <p style={styles.text}>
        {initialAnswer === "no"
          ? "I [username] do not have my spouse, parents, siblings, and children working as advisors with ICICI Pru or any other insurance companies."
          : "I [username], have either my spouse, parents, siblings, and children working as an advisor with ICICI Pru or any other insurance companies and I have declared the details in the conflict of interest link."}
      </p>
      <div style={styles.buttonContainer}>
        {recording && isTimerActive && seconds !== 0 ? (
          <div>
            <p style={timerStyle}>{`00:${formattedSeconds}`}</p>
            <button style={styles.recordButton} onClick={handleNext}>
              Next
            </button>
          </div>
        ) : (
          <div>
            <button style={styles.recordButton} onClick={()=>handleRecord()}>
              Start Recording
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecordingScreen;
